import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum FeedSubscriptionLogResolverErrorStatesEnum {
    GetFeedSubscriptionLogFailed = ErrorStateScheduleEnum.FeedSubscriptionLogFormStatesStartIndex,
    GetFeedSubscriptionLogNoData,
    GetFeedSubscriptionLogNoBundleData,
    GetBundleDataFailed,
    GetUserAccountsFailed,
    GetPlatformFeTradingPlatformFailed
}
